/** Programmazione oraria per zona e per giorno (RF-15) e profili rapidi (RF-16). */

export type GiornoSettimana = 0 | 1 | 2 | 3 | 4 | 5 | 6; // 0 = lunedì

export const GIORNI_SETTIMANA: readonly GiornoSettimana[] = [0, 1, 2, 3, 4, 5, 6];

export interface FasciaOraria {
  /** "HH:MM" */
  da: string;
  /** "HH:MM" */
  a: string;
  setpoint: number;
}

export interface ProgrammaOrario {
  zonaId: string;
  attivo: boolean;
  giorni: Record<GiornoSettimana, FasciaOraria[]>;
}

export type ProfiloRapido = 'CASA' | 'FUORI' | 'NOTTE' | 'VACANZA';

export const PROFILI_RAPIDI: readonly ProfiloRapido[] = ['CASA', 'FUORI', 'NOTTE', 'VACANZA'];

/** ⚠️ Valori predefiniti assunti: l'installatore li adatta all'impianto. */
export const SETPOINT_PROFILO: Record<ProfiloRapido, number> = {
  CASA: 21,
  FUORI: 17,
  NOTTE: 19,
  VACANZA: 12,
};

export function programmaVuoto(zonaId: string): ProgrammaOrario {
  return {
    zonaId,
    attivo: false,
    giorni: { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] },
  };
}

export function programmaTipico(zonaId: string, giorno: number, notte: number): ProgrammaOrario {
  const feriale: FasciaOraria[] = [
    { da: '06:30', a: '08:30', setpoint: giorno },
    { da: '17:30', a: '22:30', setpoint: giorno },
  ];
  const festivo: FasciaOraria[] = [{ da: '08:00', a: '23:00', setpoint: giorno }];
  void notte;
  return {
    zonaId,
    attivo: true,
    giorni: { 0: feriale, 1: feriale, 2: feriale, 3: feriale, 4: feriale, 5: festivo, 6: festivo },
  };
}

export function minutiDaOrario(hhmm: string): number {
  const [h, m] = hhmm.split(':').map(Number);
  return (h ?? 0) * 60 + (m ?? 0);
}

/** Fascia attiva in un dato istante, se esiste. */
export function fasciaAttiva(programma: ProgrammaOrario, data: Date): FasciaOraria | undefined {
  if (!programma.attivo) return undefined;
  const giorno = ((data.getDay() + 6) % 7) as GiornoSettimana;
  const minuti = data.getHours() * 60 + data.getMinutes();
  return programma.giorni[giorno].find((f) => minutiDaOrario(f.da) <= minuti && minuti < minutiDaOrario(f.a));
}

export function fasceValide(fasce: FasciaOraria[]): boolean {
  const ordinate = [...fasce].sort((a, b) => minutiDaOrario(a.da) - minutiDaOrario(b.da));
  for (let i = 0; i < ordinate.length; i += 1) {
    const f = ordinate[i]!;
    if (minutiDaOrario(f.da) >= minutiDaOrario(f.a)) return false;
    const next = ordinate[i + 1];
    if (next && minutiDaOrario(next.da) < minutiDaOrario(f.a)) return false;
  }
  return true;
}
